<template>
  <div class="row no-gutters" @click="selectCar(car.id)">
    <div class="col" :class="{ 'last-selected': lastSelectedId === car.id }">
      <div class="card map-card">
        <!--div class="selection" :style="isSelected ? {'background-color': 'gray'} : {}"></div-->
        <div class="col-sm">
          {{ car.brand }} {{ car.model }} ({{ car.registration_plate }})
        </div>
        <div class="card-footer">
          <WatchState :location="car.lastState" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swal from 'sweetalert2'
import { mapGetters, mapActions, mapState } from 'vuex'
import commandsAPI from '@/api/commands'
export default {
  name: 'MapCard',
  props: ['car'],
  data () {
    return {
      sTrackDate: null,
      eTrackDate: null
    }
  },
  mounted () {
    const now = new Date()
    const hrAgo = new Date(Date.now() - 60 * 60 * 1000)
    this.sTrackDate = `${hrAgo.toLocaleDateString('en-CA')}T${hrAgo.getHours().toString().padStart(2, '0')}:${hrAgo.getMinutes().toString().padStart(2, '0')}`
    this.eTrackDate = `${now.toLocaleDateString('en-CA')}T${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}`
  },
  computed: {
    isSelected () {
      return this.getSelected && this.car.id === this.getSelected.id
    },
    ...mapGetters('taxi/mapcars', [
      'getSelected'
    ]),
    ...mapState('taxi/mapcars', {
      lastSelectedId: state => state.lastSelectedId
    })
  },
  methods: {
    ...mapActions('taxi/mapcars', [
      'selectCar',
      'getTrack',
      'clearTrack'
    ]),
    toLocalTime (date) {
      date = new Date(date + 'Z')
      return date.toLocaleString()
    },
    track () {
      this.getTrack({ id: this.getSelected.id, sTime: new Date(this.sTrackDate).toISOString(), eTime: new Date(this.eTrackDate).toISOString() })
    },
    disableIgnition () {
      Swal.fire({
        title: 'Отключить зажигание?',
        showCancelButton: true,
        confirmButtonText: 'Отправить',
        cancelButtonText: 'Назад'
      }).then((result) => {
        if (result.value) {
          commandsAPI.sendCommand({ imei: this.getSelected.imei, command: 'setdigout 1' })
            .then(answer => this.deviceAnswer(answer.result.response))
        }
      })
    },
    enableIgnition () {
      commandsAPI.sendCommand({ imei: this.getSelected.imei, command: 'setdigout 0' })
        .then(answer => this.deviceAnswer(answer.result.response))
    },
    anyCommand () {
      Swal.fire({
        title: 'Введите комманду',
        input: 'text',
        inputValidator: (value) => {
          if (!value) {
            return 'Команда не может быть пустой!'
          }
        }
      }).then(command => {
        if (!command.dismiss) {
          commandsAPI.sendCommand({ imei: this.getSelected.imei, command: command.value })
            .then(answer => this.deviceAnswer(answer.result.response))
        }
      })
    },
    deviceAnswer (answer) {
      Swal.fire({
        title: 'Ответ устройства',
        text: answer
      })
    }
  }
}
</script>
<style scoped>
  .map-card .card-body {
    padding: 3px 2px 3px 15px;
  }
  .map-card .card-footer {
    padding: 2px 0 2px 15px;
  }
  .map-card:hover {
    cursor: pointer;
  }
  .device-status {
    float: right;
    margin-right: 0.4rem;
  }
  .selection {
    position: absolute;
    width: 5px;
    height: 100%;
    border-radius: 5px;
  }
  .track-menu {
    margin-left: 0px;
  }
  .map-card .card-body .row {
    margin-bottom: 0.4rem;
  }
  .command-dropdown {
    float: right;
  }
  .btn-clear {
    margin-left: 10px;
  }
  .last-selected {
    border-radius: 3px;
    border-left: 3px solid rgba(64, 64, 64, 0.7);
  }
</style>
